// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniUserDetail-modulecontainer2LY","avatar":"MiniUserDetail-moduleavatariF4","name":"MiniUserDetail-modulename1og"};